module.exports = __webpack_public_path__ + "static/media/19ESCAP45.0aa4277f.jpg";